export default {
  BLOCK: 'block',
  ORDER: 'order',
  PLANNING: 'planning',
  NON_PLANNING_BLOCK: 'nonPlanningBlock',
};
